import React, { Component } from "react";

import { Grid } from "semantic-ui-react";

class InformationOverlay extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <Grid
        columns="equal"
        divided
        style={{ marginLeft: "0rem", marginRight: "-3rem" }}
      >
        <Grid.Row style={{ paddingTop: "0em", paddingBottom: "0em" }}>
          <Grid.Column>Add some info</Grid.Column>
        </Grid.Row>
        <Grid.Row
          style={{
            paddingTop: "0em",
            paddingBottom: "0em",
            paddingLeft: "0rem",
          }}
        >
          <Grid.Column></Grid.Column>
        </Grid.Row>
      </Grid>

      // </Segment>
    );
  }
}

export default InformationOverlay;
